"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaEnvelope } from "react-icons/fa";
import { getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  authorName?: FieldConfig;
  authorTitle?: FieldConfig;
  authorAvatar?: FieldConfig;
  authorBio?: FieldConfig;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export default function HorizontalCommentsIconsNews(t0) {
  const $ = _c(43);
  const {
    authorName: t1,
    authorTitle: t2,
    authorAvatar: t3,
    authorBio: t4,
    priority: t5,
    imageMetadata
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "\u0B9A\u0BBE\u0BAE\u0BCD \u0BAE\u0BC7\u0BA4\u0BCD\u0BAF\u0BC2",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const authorName = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "Senior Subeditor",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const authorTitle = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const authorAvatar = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: "\u0BB2\u0BCB\u0BB0\u0BC6\u0BAE\u0BCD \u0B87\u0BAA\u0BCD\u0B9A\u0BAE\u0BCD \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC1 \u0B85\u0B9A\u0BCD\u0B9A\u0BBF\u0B9F\u0BC1\u0BAE\u0BCD \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BA4\u0B9F\u0BCD\u0B9F\u0B9A\u0BCD\u0B9A\u0BC1\u0BA4\u0BCD \u0BA4\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BA9\u0BCD \u0BAA\u0BCB\u0BB2\u0BBF \u0B89\u0BB0\u0BC8. \u0BB2\u0BCB\u0BB0\u0BC6\u0BAE\u0BCD \u0B87\u0BAA\u0BCD\u0B9A\u0BAE\u0BCD \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC1 1500\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0BA4\u0BCA\u0BB4\u0BBF\u0BB2\u0BCD\u0BA4\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BA9\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BBE\u0BA9 \u0BAA\u0BCB\u0BB2\u0BBF \u0B89\u0BB0\u0BC8\u0BAF\u0BBE\u0B95 \u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0BB5\u0BB0\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1, \u0B85\u0BAA\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1 \u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0B85\u0B9A\u0BCD\u0B9A\u0BC1\u0BAA\u0BCD\u0BAA\u0BCA\u0BB1\u0BBF \u0B92\u0BB0\u0BC1 \u0BB5\u0B95\u0BC8 \u0BAE\u0BBE\u0BA4\u0BBF\u0BB0\u0BBF\u0BAF\u0BC8 \u0B8E\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1, \u0B85\u0BA4\u0BC8 \u0B92\u0BB0\u0BC1 \u0BB5\u0B95\u0BC8 \u0BAE\u0BBE\u0BA4\u0BBF\u0BB0\u0BBF \u0BAA\u0BC1\u0BA4\u0BCD\u0BA4\u0B95\u0BA4\u0BCD\u0BA4\u0BC8 \u0B89\u0BB0\u0BC1\u0BB5\u0BBE\u0B95\u0BCD\u0B95\u0BBF\u0BAF\u0BA4\u0BC1. \u0B87\u0BA4\u0BC1 \u0B90\u0BA8\u0BCD\u0BA4\u0BC1 \u0BA8\u0BC2\u0BB1\u0BCD\u0BB1\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD \u0BAE\u0B9F\u0BCD\u0B9F\u0BC1\u0BAE\u0BB2\u0BCD\u0BB2, \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0BA3\u0BC1 \u0BA4\u0B9F\u0BCD\u0B9F\u0B9A\u0BCD\u0B9A\u0BC1 \u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD \u0BAA\u0BBE\u0BAF\u0BCD\u0B9A\u0BCD\u0B9A\u0BBF\u0BAF\u0BA4\u0BC1, \u0B85\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0BAE\u0BBE\u0BB1\u0BBE\u0BAE\u0BB2\u0BCD \u0B89\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1.",
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const authorBio = t9;
  const priority = t5 === undefined ? false : t5;
  const authorNameValue = authorName?.value || "";
  const authorTitleValue = authorTitle?.value || "";
  const authorAvatarValue = authorAvatar?.value || "";
  const authorBioValue = authorBio?.value || "";
  let t10;
  if ($[8] !== authorAvatar?.customClass || $[9] !== authorAvatar?.hidden || $[10] !== authorAvatarValue || $[11] !== authorNameValue || $[12] !== imageMetadata || $[13] !== priority) {
    t10 = !authorAvatar?.hidden && <div className={`relative w-14 h-14 rounded-full bg-gray-300 flex-shrink-0 overflow-hidden ${authorAvatar?.customClass || ""}`}>{authorAvatarValue ? <Image src={authorAvatarValue} alt={authorNameValue} fill={true} priority={priority} className="object-cover" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} sizes="56px" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /> : <div className="w-full h-full flex items-center justify-center text-808080-500 text-2xl font-bold">{authorNameValue.charAt(0)}</div>}</div>;
    $[8] = authorAvatar?.customClass;
    $[9] = authorAvatar?.hidden;
    $[10] = authorAvatarValue;
    $[11] = authorNameValue;
    $[12] = imageMetadata;
    $[13] = priority;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== authorName?.customClass || $[16] !== authorName?.hidden || $[17] !== authorNameValue) {
    t11 = !authorName?.hidden && <h4 className={`text-18-tamil-700 text-1B1B1B ${authorName?.customClass || ""}`}>{authorNameValue}</h4>;
    $[15] = authorName?.customClass;
    $[16] = authorName?.hidden;
    $[17] = authorNameValue;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== authorTitle?.customClass || $[20] !== authorTitle?.hidden || $[21] !== authorTitleValue) {
    t12 = !authorTitle?.hidden && <p className={`text-14-tamil-500 text-4D4D4D ${authorTitle?.customClass || ""}`}>{authorTitleValue}</p>;
    $[19] = authorTitle?.customClass;
    $[20] = authorTitle?.hidden;
    $[21] = authorTitleValue;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12) {
    t13 = <div>{t11}{t12}</div>;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t10 || $[27] !== t13) {
    t14 = <div className="flex gap-3 items-center">{t10}{t13}</div>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <button className="text-808080 transition-colors"><FaFacebook size={16} /></button>;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <button className="text-808080 transition-colors"><FaInstagram size={16} /></button>;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <button className="text-808080 transition-colors"><FaTwitter size={16} /></button>;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <button className="text-808080 transition-colors"><FaYoutube size={16} /></button>;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="flex items-center gap-3">{t15}{t16}{t17}{t18}<button className="text-808080 transition-colors"><FaEnvelope size={16} /></button></div>;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t14) {
    t20 = <div className="flex items-start justify-between">{t14}{t19}</div>;
    $[34] = t14;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== authorBio?.customClass || $[37] !== authorBio?.hidden || $[38] !== authorBioValue) {
    t21 = !authorBio?.hidden && <p className={`text-14-tamil-500 text-4D4D4D leading-[1.5] line-clamp-4 pt-5 ${authorBio?.customClass || ""}`}>{authorBioValue}</p>;
    $[36] = authorBio?.customClass;
    $[37] = authorBio?.hidden;
    $[38] = authorBioValue;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t20 || $[41] !== t21) {
    t22 = <div className="bg-gray gap-4 p-4 "><div className="flex items-start"><div className="flex-1">{t20}{t21}</div></div></div>;
    $[40] = t20;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  return t22;
}